import React, { useEffect } from "react";
import { useQuery } from "@tanstack/react-query";
import { api } from "../../lib/api";
import { useAuth } from "../../context/AuthContext";
import { PortalLayout } from "../../components/portal/PortalLayout";
import { StatusBadge } from "../../components/StatusBadge";

export default function PortalAccount() {
  const { user } = useAuth();
  useEffect(() => { document.title = "Account | Sambiva Trade"; }, []);
  const { data } = useQuery({ queryKey: ["trade-dashboard"], queryFn: async () => (await api.get("/trade/dashboard")).data });

  const Row = ({ label, value }) => (
    <div className="flex justify-between py-3 border-b border-sambiva-charcoal/8 last:border-0">
      <span className="text-sambiva-muted">{label}</span>
      <span className="text-sambiva-charcoal font-medium text-right">{value}</span>
    </div>
  );

  return (
    <PortalLayout title="Account">
      <div className="max-w-xl bg-white rounded-2xl border border-sambiva-charcoal/5 p-6 sm:p-8">
        <h3 className="font-serif text-xl text-sambiva-charcoal mb-4">Trade Account</h3>
        <div className="text-sm">
          <Row label="Company" value={user?.company_name} />
          <Row label="Contact" value={user?.name} />
          <Row label="Email" value={user?.email} />
          <Row label="Account Status" value={<StatusBadge status={user?.account_status || "Approved"} />} />
        </div>
        <p className="text-sm text-sambiva-muted mt-6">Need to update your details? Contact your Sambiva account manager at <a href="mailto:hello@sambiva.com" className="text-sambiva-red">hello@sambiva.com</a>.</p>
      </div>
    </PortalLayout>
  );
}
